import { ListOrgMembersRequestSchema, ListOrgMembersResponseSchema } from './list-org-members.schema';
/**
 * List Organization Members Endpoint Contract
 * Retrieves organization members for the current tenant, with optional status filtering
 *
 * Query Parameters:
 * - status: Filter by user status (optional). Can be single value or array.
 *
 * Examples:
 * - GET /api/v2/org-member - Returns all users
 * - GET /api/v2/org-member?status=active - Returns only active users
 * - GET /api/v2/org-member?status=active&status=pending - Returns active or pending users
 */ export const listOrgMembersContract = {
    method: 'GET',
    path: '/api/v2/org-member',
    description: 'Retrieve organization members (users) for the current tenant, optionally filtered by status',
    requestSchema: ListOrgMembersRequestSchema,
    responseSchema: ListOrgMembersResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=list-org-members.contract.js.map